import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";
// import { MdComputer } from "react-icons/md";
import { FooterLogo } from '../../assets/icons/index'

const FooterBg = {
    backgroundColor: '#486072',
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "bottom center",
};

const Footer = () => {
    return (
        <div style={FooterBg} className="">
            <div className="bg-primary/5">
                <div className="container text-[#ffffff]">
                    <div className="grid md:grid-cols-4 md:gap-4 py-5 border-t-2 border-gray-300/10 text-black">
                        {/* brand info section */}
                        <div className="py-8 px-4 space-y-4">
                            <div className="text-2xl flex items-center gap-2 font-bold uppercase">
                                {/* <MdComputer className="text-secondary text-4xl" /> */}
                                <img src={FooterLogo} alt="" className="!w-[200px] !h-[120px]" />
                            </div>
                            <p className="text-[#ffffff] text-center fontText mt-[0]">
                                Engineering Your Dreams Into Reality
                            </p>
                            <div className="flex items-center w-full justify-between gap-5 !mt-6">
                                <a href="/" className="hover:text-secondary duration-200">
                                    <HiLocationMarker className="text-3xl" color="white" />
                                </a>
                                <a href="/" className="hover:text-secondary duration-200">
                                    <FaWhatsapp className="text-3xl" color="white" />
                                </a>
                                <a href="/" className="hover:text-secondary duration-200">
                                    <FaFacebook className="text-3xl" color="white" />
                                </a>
                                <a href="/" className="hover:text-secondary duration-200">
                                    <FaInstagram className="text-3xl" color="white" />
                                </a>
                            </div>
                        </div>
                        {/* Footer Links  */}
                        <div className="grid max-md:grid-cols-1 md:grid-cols-3 md:col-span-3 md:ml-14">
                            <div className="py-8 px-4 text-[#ffffff] fontText">
                                <h1 className="sm:text-xl text-xl font-bold sm:text-left text-justify mb-5">
                                    Important Links
                                </h1>
                                <ul className="flex flex-col gap-3">
                                    <li>
                                        <a href="/" className="hover:text-secondary duration-200">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/about-us" className="hover:text-secondary duration-200">
                                            About
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/services" className="hover:text-secondary duration-200">
                                            Services
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/" className="hover:text-secondary duration-200">
                                            Porfolio
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/gallery" className="hover:text-secondary duration-200">
                                            Gallary
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/portfolio" className="hover:text-secondary duration-200">
                                            Porfolio
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/contact-us" className="hover:text-secondary duration-200">
                                            Contact Us
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="py-8 px-4 text-[#ffffff] fontText">
                                <h1 className="sm:text-xl text-xl font-bold sm:text-left text-justify mb-5">
                                    What We Do
                                </h1>
                                <ul className="flex flex-col gap-3">
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Commercial Project
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Residential Project
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Smart Class & Anganwadi
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Renovation
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Painting
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            Education Garden Development
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            All Kind of Civil Work
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div className="py-8 px-4 text-[#ffffff]  fontText">
                                <h1 className="sm:text-xl text-xl font-bold sm:text-left text-justify mb-5">
                                    Contact Details
                                </h1>
                                <ul className="flex flex-col gap-3">
                                    <li>
                                        <a href="tel:+916353886588" className="hover:text-secondary duration-200">
                                            +91 6353 886 588
                                        </a>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            <a
                                                href="mailto:shreedattguru03@gmail.com"
                                                className="hover:underline"
                                            >
                                                shreedattguru03@gmail.com
                                            </a>
                                        </p>

                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            <a
                                                href="https://maps.app.goo.gl/eR6im4HnRH3qKFng7"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="hover:underline"
                                            >
                                                TF - 27 Siddheshwar Hallmark, Ajwa Road, Vadodara - 390019
                                            </a>
                                        </p>
                                    </li>
                                    <li>
                                        <p className="hover:text-secondary duration-200">
                                            GST NO: 24BXWPS9756D2ZL
                                        </p>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    {/* copyright section  */}
                    <div className="mt-8">
                        <div className="text-center py-6 border-t-2 border-gray-800/10">
                            <span className="text-sm text-[#fff] max-w-[320px]">
                                Copyright © 2025 All Rights Reserved by Shree DattGuru Enterprise 
                                <a href="https://www.bhautik.co.in/" target="_blank" rel="noreferrer">
                                    &nbsp; Made with ❤️
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;